import { render, staticRenderFns } from "./hallOfFameDeleteDialog.vue?vue&type=template&id=fb6b63b8&"
import script from "./hallOfFameDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./hallOfFameDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports